let cacheSize = parseInt(localStorage.getItem('pageSize'))
const tableData = {
    inventory_post:{
        loading:false,
        isFullscreen:false,
        selection: 'single',
        selected: [],
        data: [],
        count: 0,
        pagination: { rowsPerPage: cacheSize?cacheSize:30, rowsNumber: 3, page: 1, query: {} },
        tools: {
            show_toolbar: true,
        },
        columns: [
            {name: 'id', align: 'left', label: 'id', field: 'id', sortable: true},
            {name: 'F_MaterialNo', align: 'left', label: '物料订货号', field: 'F_MaterialNo', sortable: true},
            {name: 'F_Qty', align: 'left', label: '实时库存数量', field: 'F_Qty', sortable: true},
            {name: 'created_date', align: 'left', label: '上报日期', field: 'created_date', sortable: true,format: (val) => `${val ? val : ''}`},
            {name: 'pushed_time', align: 'left', label: '上报时间', field: 'pushed_time', sortable: true,format: (val) => `${val ? val : ''}`},
            {name: 'state', align: 'left', label: '上报状态', field: 'state', sortable: true},
            {name: 'message', align: 'left', label: '消息', field: 'message', sortable: true},
        ]
    }
};
const state = () => ({
    inventory: Object.assign({}, tableData),
})
const getters = {
    getInventoryPost: state => state.inventory.inventory_post,
}
const mutations ={
    setList(state, data) {
        state.inventory.inventory_post.pagination.rowsNumber = data.count
        state.inventory.inventory_post.data = data.data
    },
    ['refreshTableHeight'](state, data) {
        state.inventory.inventory_post.maxHeight = (data -55) + 'px';
        // state.inventory.inventory_post.height = (data -35) + 'px'
    },
    ['clearData'](state, data) {
        state.inventory.inventory_post.pagination.page = 1
        state.inventory.inventory_post.data = []
    }
}
const actions = {
    async ['fetch-list']({ state, dispatch, rootState }, payload) {
        if (state.inventory.inventory_post.loading == true) return
        let msg = { command: "inventory__list", message: payload, to: "client" }
        dispatch('channel/socket_send', msg, { root: true })
        state.inventory.inventory_post.loading = true
    },
    async ['return_inventory__list']({ state, commit }, payload) {
        state.inventory.inventory_post.loading = false;
        if (payload.success) {
            commit('setList', payload.data)
        }
    },
    async['export_excel']({ state, dispatch, rootState }, payload) {
        state.inventory.inventory_post.loading = true
        let msg = { command: "inventory__export", message: payload, to: "client" }
        dispatch('channel/socket_send', msg, { root: true })
        dispatch('response/info-tip', { message: '正在导出' }, { root: true })
    },
    async['return_inventory__export']({ state, dispatch, rootState }, payload) {
        if (payload.success) {
            window.open(payload.data, '_blank')
            dispatch('response/success-tip', { message: '导出成功' }, { root: true })
        }
        state.inventory.inventory_post.loading = false;
    },
}
export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
}
